import PILLARS from "@/lib/pillars.json";

export const ACTIVE_COUNTRIES = ["spain"];
export const ROUTE_SLUG = { general: "moving-to-spain", work: "work", retire: "retire", home: "home" };
export const PROFILE_TO_ROUTE = { work: "work", retire: "retire", real_estate: "home" };

export const pillarPath = (country, route) => `/${country}/${ROUTE_SLUG[route] || route}/`;
export const getPillar = (country, slug) => (ACTIVE_COUNTRIES.includes(country) && PILLARS[country]?.[slug]) || null;

// Best pillar for a post (country_tag + route_tags). Falls back to the general hub of the country.
export function pillarForPost(post) {
  const country = (post?.country_tag || "spain").toLowerCase();
  if (!ACTIVE_COUNTRIES.includes(country)) return null;
  const tags = (post?.route_tags || []).filter((t) => t !== "general");
  const route = tags.length === 1 ? tags[0] : "general";
  const p = PILLARS[country]?.[ROUTE_SLUG[route]];
  return p ? { path: pillarPath(country, route), label: p.breadcrumb, route } : null;
}

// Related ranking: same country → route_tags overlap → same category. Max 3.
export function rankRelated(posts, current, max = 3) {
  if (!current) return [];
  const cc = (current.country_tag || "").toLowerCase();
  const tags = new Set(current.route_tags || []);
  return posts
    .filter((p) => p.slug !== current.slug && p.published !== false && (p.country_tag || "").toLowerCase() === cc)
    .map((p) => ({ p, s: (p.route_tags || []).filter((t) => tags.has(t)).length * 2 + (p.category === current.category ? 1 : 0) }))
    .sort((a, b) => b.s - a.s)
    .slice(0, max)
    .map((x) => x.p);
}
